import { defa }      from 'defa-object';
import Model  from 'scripts/poppet/model';

/**
 * defa.models.LocationOptions
 * The DEFA LocationOptions model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	locationUrl: apiHost + '/locations/search?name=',
	page : '&page=',
};

const LocationOptions = Model.extend( {
	searchInput : '',
	page: 0,

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	url: function ( ) {
		return api.locationUrl + this.searchInput + api.page + this.page;
	},

	defaults: {
		currentPage: null,
		totalPages: 0,
		locations: [],
	},
	
	fetchLocations: function( input, page ) {
		this.searchInput = input.toLowerCase();
		this.page = page;
		this.fetch();
	},

	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	parse: function( response ) {
		this.set( { locations: [] } );
		for(let index in response.results) {
			this.get('locations').push( response.results[index] );
		}
		this.set({currentPage: response.currentPage});
		this.set({totalPages: response.totalPages});
	},

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	locationNames: function() {
		return this.get('locations');
	},
	
});

export default LocationOptions;